export default __webpack_public_path__ + "static/media/img1.6e485692.png";